import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Azure } from "@graylog/enterprise-api";
import formValidation from "./utils/formValidation";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const [showProxyOptions, setShowProxyOptions] = useState(false);
  const { connectionString } = formData;
  const handleShowProxyChange = (event, fieldData) => {
    const enableProxy = event.target.checked;
    setShowProxyOptions(enableProxy);
    if (!enableProxy) {
      formData.proxyOptions.value = "";
    }
    onChange(event, fieldData);
  };
  const handleSubmit = () => {
    var _a, _b, _c, _d, _e;
    const fetcher = Azure.checkCredentials({
      azure_event_hub_name: ((_a = formData == null ? void 0 : formData.eventHubName) == null ? void 0 : _a.value) || "",
      azure_connection_string: ((_b = formData == null ? void 0 : formData.connectionString) == null ? void 0 : _b.value) || "",
      azure_consumer_group: ((_c = formData == null ? void 0 : formData.consumerGroup) == null ? void 0 : _c.value) || "",
      azure_enable_proxy: ((_d = formData == null ? void 0 : formData.enableProxy) == null ? void 0 : _d.value) || false,
      azure_proxy_options: ((_e = formData == null ? void 0 : formData.proxyOptions) == null ? void 0 : _e.value) || ""
    });
    fetcher.then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: t("azure.errors.unable_to_connect")
        });
      }
    }).catch((err) => {
      setFormError({
        full_message: err.message,
        nice_message: t("azure.errors.unable_to_connect")
      });
    });
  };
  const proxyIsValid = () => {
    var _a, _b;
    const missingProxyOptions = ((_a = formData == null ? void 0 : formData.proxyOptions) == null ? void 0 : _a.value) === "";
    const proxyEnabled = !!((_b = formData == null ? void 0 : formData.enableProxy) == null ? void 0 : _b.value) || false;
    return !(proxyEnabled && missingProxyOptions) || false;
  };
  const isFormValid = () => {
    const formValid = !formValidation.isFormValid(
      ["azureName", "eventHubName", "connectionString", "consumerGroup"],
      formData
    );
    return formValid && proxyIsValid();
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.verify_connection_and_proceed"),
      disabled: !isFormValid(),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "azureName",
        type: "text",
        fieldData: formData.azureName,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        defaultValue: connectionString == null ? void 0 : connectionString.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "eventHubName",
        type: "text",
        fieldData: formData.eventHubName,
        onChange,
        label: t("azure.fields.event_hub_name"),
        help: t("azure.fields.event_hub_name_help"),
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "connectionString",
        type: "password",
        onChange,
        fieldData: formData.connectionString,
        help: t("azure.fields.connection_string_help"),
        label: t("azure.fields.connection_string"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "consumerGroup",
        type: "text",
        onChange,
        fieldData: formData.consumerGroup,
        label: t("azure.fields.consumer_group"),
        help: t("azure.fields.consumer_group_help"),
        placeholder: "$Default",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "checkbox",
        className: "",
        id: "enableProxy",
        onChange: handleShowProxyChange,
        fieldData: formData.enableProxy,
        label: t("azure.fields.enable_proxy")
      }
    ),
    showProxyOptions && /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "proxyOptions",
        type: "text",
        onChange,
        fieldData: formData.proxyOptions,
        label: t("azure.fields.proxy_uri"),
        placeholder: "https://<proxy-host>:5672",
        help: t("azure.fields.proxy_uri_help")
      }
    )
  );
};
export default StepAuthorize;
